import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';
import { City } from '../models/city';
import { Sport } from '../models/sport';

@Injectable({providedIn: 'root'})
export class ReferenceApi {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {}

  async getCities(): Promise<City[]> {
    return this.httpClient
      .get(`${this.configService.get('apiUrl')}/api/v1/reference/cities/`)
      .pipe(
        map(data => City.toFront(data))
      ).toPromise();
  }

  async getSports(): Promise<Sport[]> {
    return this.httpClient
      .get(`${this.configService.get('apiUrl')}/api/v1/sport/`)
      .pipe(
        map(data => Sport.toFront(data))
      ).toPromise();
  }
}
